import { render, staticRenderFns } from "./appointment-bind.vue?vue&type=template&id=ae85134a&scoped=true"
import script from "./appointment-bind.vue?vue&type=script&lang=js"
export * from "./appointment-bind.vue?vue&type=script&lang=js"
import style0 from "./appointment-bind.vue?vue&type=style&index=0&id=ae85134a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae85134a",
  null
  
)

export default component.exports